import React, { useState } from 'react';
import './contact.css';
import Header from '../components/header';
import SpotlightCard from '../components/SpotlightCard';
import Footer from '../components/footer';

const contacts = [
  {
    id: 'email',
    emoji: '✉️',
    label: 'Email',
    value: 'me@doazhu.pro',
    link: 'mailto:me@doazhu.pro',
    spotlightColor: 'rgba(234, 67, 53, 0.3)',
    accentColor: '#EA4335',
    copyable: true,
  },
  {
    id: 'telegram',
    emoji: '💬',
    label: 'Telegram',
    value: '@Doazhu',
    link: 'https://t.me/Doazhu',
    spotlightColor: 'rgba(0, 136, 204, 0.3)',
    accentColor: '#0088cc',
    copyable: false,
  },
  {
    id: 'vk',
    emoji: '🔵',
    label: 'ВКонтакте',
    value: '@doazhu',
    link: 'https://vk.com/doazhu',
    spotlightColor: 'rgba(76, 117, 163, 0.3)',
    accentColor: '#4C75A3',
    copyable: false,
  },
  {
    id: 'github',
    emoji: '🐙',
    label: 'GitHub',
    value: 'github.com/doazhu',
    link: 'https://github.com/doazhu',
    spotlightColor: 'rgba(110, 84, 148, 0.3)',
    accentColor: '#9575CD',
    copyable: false,
  },
];

function Contact() {
  const [copied, setCopied] = useState(null);

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <div className="contact-page">
      <Header />

      <main className="contact-main-new">
        {/* Hero */}
        <div className="contact-hero-new">
          <span className="contact-eyebrow">Связаться</span>
          <h1 className="contact-title-new">
            Давай создадим<br />
            что-то <span className="contact-accent">крутое</span>
          </h1>
          <p className="contact-subtitle-new">
            Открыт для новых проектов, коллабораций и интересных идей
          </p>

          {/* Status */}
          <div className="contact-status-new">
            <div className="status-dot-new" />
            <span>Сейчас открыт для новых проектов</span>
          </div>
        </div>

        {/* Contact Cards */}
        <div className="contact-grid-new">
          {contacts.map((contact) => (
            <SpotlightCard
              key={contact.id}
              spotlightColor={contact.spotlightColor}
              style={{ padding: 0 }}
            >
              <a
                href={contact.link}
                target={contact.link.startsWith('http') ? '_blank' : undefined}
                rel={contact.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="contact-card-link cursor-target"
                style={{ '--accent': contact.accentColor }}
              >
                <div className="contact-card-emoji">{contact.emoji}</div>
                <div className="contact-card-info-new">
                  <span className="contact-card-label-new">{contact.label}</span>
                  <span className="contact-card-value-new">{contact.value}</span>
                </div>
                <div className="contact-card-arrow-new">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M7 17L17 7M17 7H7M17 7V17" />
                  </svg>
                </div>
              </a>
            </SpotlightCard>
          ))}
        </div>

        {/* CTA Cards */}
        <div className="contact-cta-grid">
          <SpotlightCard
            spotlightColor="rgba(204, 255, 0, 0.2)"
            style={{ padding: '2.5rem' }}
          >
            <div className="cta-card-inner">
              <div className="cta-card-emoji">🚀</div>
              <h2 className="cta-card-title">Есть идея?</h2>
              <p className="cta-card-text">Напиши мне — обсудим детали и начнём работу</p>
              <button
                className="cta-card-btn cursor-target"
                onClick={() => copyToClipboard('me@doazhu.pro', 'email')}
              >
                {copied === 'email' ? '✓ Скопировано!' : 'Скопировать email'}
              </button>
            </div>
          </SpotlightCard>

          <SpotlightCard
            spotlightColor="rgba(0, 136, 204, 0.25)"
            style={{ padding: '2.5rem' }}
          >
            <div className="cta-card-inner">
              <div className="cta-card-emoji">⚡</div>
              <h2 className="cta-card-title">Быстрый ответ</h2>
              <p className="cta-card-text">Отвечаю в Telegram обычно в течение часа</p>
              <a
                href="https://t.me/Doazhu"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-card-btn cta-card-btn-telegram cursor-target"
              >
                Написать в Telegram
              </a>
            </div>
          </SpotlightCard>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
